module.exports = __webpack_public_path__ + "static/img/iOS16.7913f3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IndexImages/iOS16.jpg
// module id = dBH9
// module chunks = 0